<div fxLayout="column" fxFill>
  <div fxLayout="row" fxLayoutAlign="space-between center" fxFlex="100px" class="imc--cap">

    <div fxLayout="row" class="logosContainer">
      <img class="logoGeneralitat" [src]="idiomaActual == 'es' ? 'assets/images/gv_conselleria_educacion_bn_cast.png' : 'assets/images/gv_conselleria_educacio_bn_val.png'" alt="">
      <img class="logoSecretaria" [src]="idiomaActual == 'es' ? 'assets/images/Logo_secretaria_digital_cast.png' : 'assets/images/Logo_secretaria_digital_vlc.png'" alt="">
    </div>
    <div class="separador"></div>

    <div fxLayout="row" fxLayoutGap="4px" class="imc--opcions">

      <div>
        <mat-button-toggle-group #idioma="matButtonToggleGroup" (change)="changeLanguage(idioma.value)" multiple="false"
          [(ngModel)]="idiomaActual" class="imc--idioma">
          <mat-button-toggle [value]="'es'">
            <span>{{ 'LANG.ES' | translate }}</span>
          </mat-button-toggle>
          <mat-button-toggle [value]="'ca'">
            <span>{{ 'LANG.CA' | translate }}</span>
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>

      <div *ngIf="salir">
        <button mat-raised-button class="mat-button imc--eixir" (click)="volver()">
          <mat-icon>exit_to_app</mat-icon>
          {{'LANG.SALIR' | translate}}
        </button>
      </div>
    </div>

  </div>

  <mat-card class="imc--default-container">
    <mat-card-header>
      <mat-icon *ngIf="!!icono" mat-card-avatar>
        {{ icono }}
      </mat-icon>
      <mat-card-title>
        {{ titulo | translate }}
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <ng-container *ngTemplateOutlet="template"></ng-container>
    </mat-card-content>
  </mat-card>

</div>